import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
interface NavBarProps {
  onLogout: () => void;
}

const NavBar: React.FC<NavBarProps> = ({ onLogout }) => {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const navigate = useNavigate();
  const handleLogout = () => {
    onLogout();
    navigate("/");
  };
  return (
    <nav
      style={{
        padding: "0.5rem 2rem",
        backgroundColor: "#f9f9f9",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        boxSizing: "border-box",
        borderBottom: "1px solid #e0e0e0",
        fontFamily: "'Arial', sans-serif",
      }}
    >
      {/* App Title */}
      <div style={{ fontWeight: "bold", fontSize: "1.2rem", color: "#333" }}>
        UPTTB
      </div>

      <div
        style={{
          display: "flex",
          gap: "1.2rem",
          alignItems: "center",
        }}
      >
        <Link
          to="/edit"
          style={{
            textDecoration: "none",
            color: "#555",
            fontSize: "0.95rem",
            transition: "color 0.2s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#007BFF")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
        >
          Start New Edit
        </Link>
        <Link
          to="/my-edits"
          style={{
            textDecoration: "none",
            color: "#555",
            fontSize: "0.95rem",
            transition: "color 0.2s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#007BFF")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
        >
          My Edits
        </Link>
        <button onClick={handleLogout}>Logout</button>
      </div>

      {/* User Profile Section */}
      {user && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <img
            src={user.picture}
            alt={`${user.name}'s Profile`}
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <span
            style={{ fontWeight: "500", fontSize: "0.9rem", color: "#333" }}
          >
            {user.name}
          </span>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
